import { Box } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import CustomerPresencePopover from "components/Customers/Presence/Popover";
import CopyableCode from "components/Shared/CopyableCode";
import LabeledValue from "components/Shared/LabeledValue";
import TagList from "components/Shared/TagList";

const fragment = gql(/* GraphQL */ `
  fragment CustomerProductPresenceTableCell on SkuBrandOrderingPlatform {
    id
    itemCode
    skuBrandDistributionCenters(
      first: 3
      orderBy: DISTRIBUTION_CENTER_NAME_ASC
      filter: {
        brandDistributionCenter: {
          distributionCenter: { name: { isNull: false } }
        }
      }
    ) {
      totalCount
      nodes {
        id
        brandDistributionCenter {
          id
          distributionCenter {
            id
            name
          }
        }
      }
    }
  }
`);

type Props = {
  skuBrandOrderingPlatform: FragmentType<typeof fragment>;
};

export default function CustomerProductPresenceTableCell({
  skuBrandOrderingPlatform,
}: Props) {
  const sbop = getFragmentData(fragment, skuBrandOrderingPlatform);
  return (
    <CustomerPresencePopover skuBrandOrderingPlatformId={sbop.id}>
      <Box>
        <LabeledValue
          label="Item Code"
          value={
            sbop.itemCode && (
              <CopyableCode
                code={sbop.itemCode}
                tooltipLabel="Copy Item Code"
              />
            )
          }
          valueProps={{ justifyContent: "center" }}
          py=".25em"
          pt={0}
        />

        <LabeledValue
          label={`Distribution Center${
            sbop.skuBrandDistributionCenters.nodes.length === 1 ? "" : "s"
          }`}
          value={
            sbop.skuBrandDistributionCenters.nodes.length ? (
              <TagList
                items={sbop.skuBrandDistributionCenters.nodes}
                numTotal={sbop.skuBrandDistributionCenters.totalCount}
                getKey={(sbdc) => sbdc.id}
                getLabel={(sbdc) =>
                  sbdc.brandDistributionCenter?.distributionCenter?.name
                }
                listProps={{ justifyContent: "center" }}
                isTruncated
              />
            ) : undefined
          }
          valueProps={{ justifyContent: "center", fontSize: ".9em" }}
          py=".25em"
        />
      </Box>
    </CustomerPresencePopover>
  );
}
